const styles = {

  getWidth(width) {
    return width ? {width: width} : {};
  }

};

export default styles;



// WEBPACK FOOTER //
// ./js/mixins/styles.js